import React from "react";
const YourRugTabs = ({ activeTabs, selectTabInYourRug, texts }) => {
  return (
    <div className="text-center your-rug-tab">
      <button
        className={"your-rug-tab-active"}
        onClick={() => selectTabInYourRug("select_size")}
      >
        {texts.size_selection}
      </button>
      <button
        className={
          activeTabs === "select_pic" || activeTabs === "confirm_and_pay"
            ? "your-rug-tab-active"
            : ""
        }
        onClick={() => {
          if (activeTabs === "confirm_and_pay")
            selectTabInYourRug("select_pic");
        }}
      >
        {texts.select_image}
      </button>
      <button
        className={
          activeTabs === "confirm_and_pay" ? "your-rug-tab-active" : ""
        }
        //  onClick={() => selectTabInYourRug("confirm_and_pay")}
      >
        {texts.confirm_and_pay}
      </button>
    </div>
  );
};

export default YourRugTabs;
